module.exports = __webpack_public_path__ + "static/media/PR2.70bafeb1.jpg";